import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import axios from "axios";
import { getCookie } from "../jwt/_helpers";
import LoaderInner from "./LoaderInner";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const ContractAmendmentModal = ({
  isContractAmendmentModalOpen,
  setIsContractAmendmentModalOpen,
  currentUser,
}) => {
  const token = getCookie("token");
  const [signingUrl, setSigningUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const defaultTemplate = {
    title: "Contract Amendment Required",
    description: "For compliance and to keep your agreement up to date, a contract amendment needs to be reviewed and signed. Please click the button below to open the latest version of your contract amendment and complete the signing process.",
    buttonText: "Please Sign",
  };
  const [templateContent, setTemplateContent] = useState(defaultTemplate);

  useEffect(() => {
    const fetchContractAmendmentTemplate = async () => {
      try {
        const response = await axios.get(
          `${API_URL}users/contract-amendment-template/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "x-api-key": X_API_KEY,
            },
          }
        );

        const data = response.data || {};
        setTemplateContent({
          title: data.modal_title_fe || defaultTemplate.title,
          description: data.modal_description_fe || defaultTemplate.description,
          buttonText: data.modal_button_text_fe || defaultTemplate.buttonText,
        });
      } catch (error) {
        console.error("Fetching contract amendment template failed:", error);
      }
    };

    if (isContractAmendmentModalOpen && currentUser) {
      fetchContractAmendmentTemplate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isContractAmendmentModalOpen, currentUser, token]);

  const handleLoadContractAmendment = async () => {
    if (!currentUser || isLoading) return;

    setIsLoading(true);
    try {
      const response = await axios.get(
        `${API_URL}users/sign-contract-amendment/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "x-api-key": X_API_KEY,
          },
        }
      );
      setSigningUrl(response.data.link);
    } catch (error) {
      console.error("Contract amendment initiation failed:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <LoaderInner show={isLoading} />
      <Modal
        isOpen={isContractAmendmentModalOpen}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <ModalHeader
          toggle={() => setIsContractAmendmentModalOpen(false)}
          close={
            <button
              type="button"
              className="close"
              onClick={() => setIsContractAmendmentModalOpen(false)}
              aria-label="Close"
              style={{
                background: "transparent",
                border: "none",
                padding: 10,
                lineHeight: 1,
                cursor: "pointer",
                fontSize: "0.7rem",
                opacity: 0.2,
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          }
        >
          <div>
            <span>{templateContent.title}</span>
          </div>
        </ModalHeader>
        <ModalBody>
          <p style={{ whiteSpace: "pre-line" }}>
            {templateContent.description}
          </p>

          {!signingUrl && (
            <div className="mt-3 text-center">
              <Button
                color="primary"
                onClick={handleLoadContractAmendment}
                disabled={isLoading || !currentUser}
              >
                {templateContent.buttonText}
              </Button>
            </div>
          )}

          {signingUrl && (
            <div className="mt-4">
              <iframe
                src={signingUrl}
                width="100%"
                height="800"
                style={{ border: "2px solid black" }}
                title="Sign Contract Amendment"
              ></iframe>
            </div>
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default ContractAmendmentModal;